import { envConfig } from './config';
import { FEATURES, GLOBAL_FEATURES } from '@enterprise/core';
import type { CacheLocation } from '@auth0/auth0-react';

export const environment = {
    get isDev() {
        return ['LOCAL', 'DEV', 'DEVELOPMENT'].indexOf(this.APP_ENV) !== -1;
    },
    get isLocal() {
        return this.APP_ENV === 'LOCAL';
    },
    APP_ENV: envConfig.name.toUpperCase(),
    adminEmail: 'connectadmin@idexx.com',
    AUTH0: {
        clientId: envConfig.config.AUTH0.CLIENT_ID,
        domain: envConfig.config.AUTH0.DOMAIN,
        scope: envConfig.config.AUTH0.SCOPE,
        audience: envConfig.config.AUTH0.AUDIENCE,
        cacheLocation: envConfig.config.AUTH0.CACHE_LOCATION as CacheLocation,
    },
    ENTERPRISE_API: {
        baseUrl: envConfig.config.ENTERPRISE_API_BASEURL,
    },
    ONBOARDING_API: {
        baseUrl: envConfig.config.ONBOARDING_API_BASEURL,
    },
    features: Object.entries(FEATURES).map(([name, value]) => ({ name, value })),
    globalFeatures: Object.entries(GLOBAL_FEATURES).map(([name, value]) => ({ name, value } as { name: string; value: string })),
};

export const TAG_MANAGER_CONFIG = envConfig.config.TAG_MANAGER;
